const $ = require('jquery')

// =========================================================================
// Module: breadcrumb
// =========================================================================
const breadcrumb = {
  init () {
    const breadItem = $('.breadcrumb__subnav')
    const breadList = breadItem.find('.breadcrumb-list')
    breadList.on('click', function(e) {
      e.stopPropagation()
    })
    breadItem.on('click', function() {
      breadList.removeClass('is-active')
      $(this).find('.breadcrumb-list').toggleClass('is-active')
      // Hack for simulating user scroll in order to toggle perfect scrollbar
      if ($(this).find('.breadcrumb-list ul').scrollTop() > 0) {
        $(this).find('.breadcrumb-list').find('ul').animate({ scrollTop: 1 }).animate({ scrollTop: 0 })
      }
    })
    breadList.find('.custom-icon--cross').on('click', function(e) {
      e.stopPropagation()
      $(this).parent().removeClass('is-active')
    })
    $(document).click(function(event) {
      if ($(event.target).closest('.breadcrumb__subnav').length === 0) {
        $('.breadcrumb-list').removeClass('is-active')
      }
    })

    // Init perfectScrollbar on breadcrumb
    breadList.find('ul').perfectScrollbar({
      minScrollbarLength: 10,
    })
  },
}

module.exports = breadcrumb



// WEBPACK FOOTER //
// ./src/modules/breadcrumb.js